export const authApiPaths = <const>{
    fido2CredentialOptions: 'auth/fido2/credentialOptions',
    fido2Credentials: 'auth/fido2/credentials',
    fido2CredentialsLabel: 'auth/fido2/credentials/label',
    fido2AssertionOptions: 'auth/fido2/assertionOptions',
    fido2Assertion: 'auth/fido2/assertion',
    completeRegistration: 'auth/completeRegistration',
};
